import { Aspect } from '@teambit/harmony';

export const DocsAspect = Aspect.create({
  id: 'teambit.docs/docs',
  dependencies: [],
  defaultConfig: {},
});

export default DocsAspect;
